module.exports = __webpack_public_path__ + "img/Frente-18-01 on.bb6d2bee.png";